export default "__VITE_ASSET__Cw1c0XAF__"